<template>
  <span class="go-back">
    <button @click="goBack">
      <v-icon name="arrow-dropleft" />
      Volver a la búsqueda
    </button>
  </span>
</template>

<script>
export default {
  methods: {
    goBack() {
      return this.$router.go(-1)
    }
  }
}
</script>
